module.exports = __webpack_public_path__ + "img/bg-sect-3-mobile.7548de2e.png";